/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon20Light = forwardRef('WeatherThermometerIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 11.05a2.5 2.5 0 1 0 1 0V6a.5.5 0 0 0-1 0v5.05Zm.5.95a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4.5a3.5 3.5 0 1 1 7 0v4.757a5.5 5.5 0 1 1-7 0V4.5ZM9.5 2A2.5 2.5 0 0 0 7 4.5v5a.5.5 0 0 1-.2.4 4.5 4.5 0 1 0 5.4 0 .5.5 0 0 1-.2-.4v-5A2.5 2.5 0 0 0 9.5 2Z" })));
});
